export default __webpack_public_path__ + "static/media/fridge1-before1-2048w.92aab125.webp";